import { useStore } from "@/lib/store";

export function MobileHeader(): JSX.Element {
  const toggleSidebar = useStore((state) => state.toggleSidebar);

  return (
    <div className="flex items-center gap-3 border-b border-cyber-border bg-cyber-surface px-3 py-2 md:hidden">
      <button
        onClick={toggleSidebar}
        className="p-2 text-cyber-muted transition-colors hover:text-cyber-cyan"
        title="Toggle sidebar"
      >
        ☰
      </button>
      <span className="text-sm font-medium text-cyber-cyan">Mako</span>
    </div>
  );
}
